import { useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface CaptchaProps {
  onVerify: (token: string | null) => void;
  sitekey: string;
}

const Captcha = ({ onVerify, sitekey }: CaptchaProps) => {
  const captchaRef = useRef<ReCAPTCHA>(null);

  const handleChange = (token: string | null) => {
    onVerify(token);
  };

  const reset = () => {
    captchaRef.current?.reset();
  };

  useEffect(() => {
    if (window) {
      (window as any).resetCaptcha = reset;
    }
    return () => {
      if (window && (window as any).resetCaptcha) {
        delete (window as any).resetCaptcha;
      }
    };
  }, []);

  return (
    <div className="captcha">
      <ReCAPTCHA
        ref={captchaRef}
        sitekey={sitekey}
        theme="dark"
        onChange={handleChange}
      />
    </div>
  );
};

export default Captcha;
